import { TooltipProps } from "recharts";
import {
  NameType,
  ValueType,
} from "recharts/types/component/DefaultTooltipContent";
import { formatMinutes, COUNTRY_CONFIG } from "../utils";
import { HolidayCountryType } from "../types";

const BarTooltip = ({
  active,
  payload,
  label,
}: TooltipProps<ValueType, NameType>) => {
  if (!active || !payload?.length) return null;

  const ht: HolidayCountryType =
    payload[0]?.payload?.holidayType ?? HolidayCountryType.NONE;

  const hasRo =
    ht === HolidayCountryType.ROMANIA || ht === HolidayCountryType.BOTH;
  const hasGe =
    ht === HolidayCountryType.GEORGIA || ht === HolidayCountryType.BOTH;

  return (
    <div
      style={{
        background: "#636262",
        padding: "10px 14px",
        borderRadius: 4,
        color: "#fff",
        fontSize: 13,
      }}
    >
      <div style={{ fontWeight: 600, marginBottom: 6 }}>{label}</div>
      {(hasRo || hasGe) && (
        <div style={{ marginBottom: 6, fontSize: 11, color: "#bbb" }}>
          {hasRo && (
            <span style={{ marginRight: 8, color: COUNTRY_CONFIG.RO.color }}>
              {COUNTRY_CONFIG.RO.label} Holiday
            </span>
          )}
          {hasGe && (
            <span style={{ color: COUNTRY_CONFIG.GE.color }}>
              {COUNTRY_CONFIG.GE.label} Holiday
            </span>
          )}
        </div>
      )}
      {payload.map((entry) => (
        <div
          key={entry.dataKey}
          style={{ display: "flex", justifyContent: "space-between", gap: 24 }}
        >
          <span style={{ color: entry.color }}>● {entry.name}</span>
          <span>
            {typeof entry.value === "number" ? formatMinutes(entry.value) : ""}
          </span>
        </div>
      ))}
    </div>
  );
};

export default BarTooltip;
